import { ChainType } from "@0xsquid/squid-types";
import type { WalletLinks } from "./types/wallet";
import { walletIconBaseUrl } from "./wallets";

export type FallbackWalletConfig = {
  chainType: ChainType;
  id: string;
  name: string;
  connectorName: string;
  icon: string;
  links: WalletLinks;
};

/**
 * Wallets to show regardless of whether they're detected.
 * Useful when we want to link to the browser extension store
 * for wallets that are automatically discovered (i.e. EVM, SOLANA, CANTON...)
 */
export const fallbackWallets: FallbackWalletConfig[] = [
  {
    chainType: ChainType.CANTON,
    id: "ldmohiccoioolenadmogclhoklmanpgi",
    name: "Send Connect",
    connectorName: "Send Connect",
    icon: `${walletIconBaseUrl}/canton-send.webp`,
    links: {
      chrome:
        "https://chromewebstore.google.com/detail/send-connect/ldmohiccoioolenadmogclhoklmanpgi",
    },
  },
  {
    chainType: ChainType.CANTON,
    id: "lpnfhpbpmlobjlgkdmnjieeihjmihhjd",
    name: "Console Wallet",
    connectorName: "Console Wallet",
    icon: `${walletIconBaseUrl}/canton-console.webp`,
    links: {
      chrome:
        "https://chromewebstore.google.com/detail/console-wallet/lpnfhpbpmlobjlgkdmnjieeihjmihhjd",
    },
  },
  {
    chainType: ChainType.CANTON,
    id: "nightly",
    name: "Nightly",
    connectorName: "Nightly",
    icon: `${walletIconBaseUrl}/nightly.webp`,
    links: {
      chrome:
        "https://chromewebstore.google.com/detail/nightly/fiikommddbeccaoicoejoniammnalkfa",
    },
  },
];
